import {
  IFavoriteSet,
  IFavoriteSetExtension,
  IFavoriteMonthExtension,
  IFavoriteMonth,
} from "../types/IFavoriteOrigins";

export const extendMonths = (
  months: IFavoriteMonth[],
): IFavoriteMonthExtension[] => {
  const parsed = months.map((m) => {
    const [year, month, day] = m.month.split("-").map(Number);
    const periods = m.split ? [m.firstPeriod, m.secondPeriod] : [m.firstPeriod];
    return { parsedMonth: { year, month, day }, periods, ...m };
  });
  return parsed;
};

export const extendFavorites = (
  favorites: IFavoriteSet[],
): IFavoriteSetExtension[] => {
  return favorites.map((favorite) => ({
    ...favorite,
    favoriteLocations: favorite.favoriteLocations.map((location, index) => ({
      ...location,
      order: index,
      months: extendMonths(location.months),
    })),
  }));
};
